
export class SOF_Stats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "SOF_Stats";
    this.scene = "SOF_Stats";
    this.data = [];
    this.page = 202;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "00014";
      }).value = (options?.player?.first_name.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "000141";
      }).value = (options?.player?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0101";
      }).value = "AGE ";      

     xml.payload.field.find((item) => {
        return item.attr.name === "0102";
      }).value =(options?.player?.age || "");      


      xml.payload.field.find((item) => {
        return item.attr.name === "0201";
      }).value = "FIGHTS";

            xml.payload.field.find((item) => {
        return item.attr.name === "0202";
      }).value = (parseInt(options?.player?.wins) + parseInt(options?.player?.losses) + parseInt(options?.player?.draws));

      xml.payload.field.find((item) => {
        return item.attr.name === "0301";
      }).value = "WON ";

        xml.payload.field.find((item) => {
        return item.attr.name === "0302";
      }).value = options?.player?.wins || "";


      xml.payload.field.find((item) => {
        return item.attr.name === "0401";
      }).value = "KOs ";

      xml.payload.field.find((item) => {
        return item.attr.name === "0501";
      }).value = "LOST ";

      xml.payload.field.find((item) => {
        return item.attr.name === "0601";
      }).value = "DRAWN ";

      xml.payload.field.find((item) => {
        return item.attr.name === "0701";
      }).value = "N/C ";

            xml.payload.field.find((item) => {
        return item.attr.name === "0402";
      }).value = (options?.player?.knockouts || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0502";
      }).value = (options?.player?.losses || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "0602";
      }).value = (options?.player?.draws || "");


      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
